import React, { useState, useRef, useEffect } from 'react';
import SEO from '../components/SEO';
import { memberNames } from './memberNames';
import './Membership.css';

const Membership = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedMember, setSelectedMember] = useState('');
  const dropdownRef = useRef(null);

  // Member names are imported from ./memberNames.js

  const filteredMembers = memberNames.filter(member =>
    member.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleMemberSelect = (member) => {
    setSelectedMember(member);
    setSearchTerm(member);
    setIsDropdownOpen(false);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setIsDropdownOpen(true);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <>
      <SEO 
        title="Membership Directory | NAB India"
        description="Search and browse NAB India member names through a fast, searchable directory."
        keywords="NAB India membership, members list, member directory, searchable members"
      />
      <div className="membership-page">
        <div className="membership-container">
          <div className="membership-header">
            <h1>Members Directory</h1>
            <p>Search from the complete NAB India members list.</p>
            <a
              className="download-form-link"
              href="/images/Membership-Form.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              Download Membership Form (PDF)
            </a>
          </div>

          <div className="membership-form-container">
            <div className="membership-form">
              <div className="form-group">
                <label htmlFor="memberName">Search Member Name</label>
                <div className="custom-dropdown" ref={dropdownRef}>
                  <input
                    type="text"
                    id="memberName"
                    value={searchTerm}
                    onChange={handleSearchChange}
                    onFocus={() => setIsDropdownOpen(true)}
                    onClick={() => setIsDropdownOpen(true)}
                    placeholder="Type to search members..."
                    autoComplete="off"
                  />
                  <div className={`dropdown-arrow ${isDropdownOpen ? 'open' : ''}`}>
                    <svg width="12" height="8" viewBox="0 0 12 8" fill="none">
                      <path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  {isDropdownOpen && (
                    <div className="dropdown-menu">
                      {filteredMembers.length > 0 ? (
                        filteredMembers.map((member) => (
                          <div
                            key={member}
                            className="dropdown-item"
                            onClick={() => handleMemberSelect(member)}
                          >
                            {member}
                          </div>
                        ))
                      ) : (
                        <div className="dropdown-item no-results">No members found</div>
                      )}
                    </div>
                  )}
                </div>
              </div>
              <p>
                Showing {filteredMembers.length} member{filteredMembers.length === 1 ? '' : 's'}
                {selectedMember ? ` | Selected: ${selectedMember}` : ''}
              </p>
            </div>

            <div className="membership-info">
              <h3>Why Join NAB India?</h3>
              <ul>
                <li>Be part of a supportive community working towards empowerment</li>
                <li>Access to exclusive programs and activities</li>
                <li>Stay updated with latest developments and opportunities</li>
                <li>Contribute to meaningful social change</li>
                <li>Network with like-minded individuals and organizations</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Membership;
